var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_27423",
    "data-name": "Group 27423",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256.987,
    height: 153.62,
    viewBox: "0 0 256.987 153.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2933",
    "data-name": "Rectangle 2933",
    width: 256.987,
    height: 153.62,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27422",
    "data-name": "Group 27422",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37984",
    "data-name": "Path 37984",
    d: "M159.637,152.12l-83.908-.6a17.136,17.136,0,0,1-17.013-17.257l.6-83.908A17.134,17.134,0,0,1,76.573,33.343l83.909.6A17.134,17.134,0,0,1,177.494,51.2l-.6,83.909a17.137,17.137,0,0,1-17.258,17.012",
    fill: "#fff0c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37985",
    "data-name": "Path 37985",
    d: "M153.726,142l-71.941-.514A13.039,13.039,0,0,1,68.84,128.351l.491-68.7,98.018.7-.491,68.7A13.04,13.04,0,0,1,153.726,142",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x2: 118.178,
    y2: 0.845,
    transform: "translate(59.162 60.024)",
    fill: "none",
    stroke: "#fc3",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37986",
    "data-name": "Path 37986",
    d: "M160.482,33.942A17.135,17.135,0,0,1,177.494,51.2l-.6,83.909a17.136,17.136,0,0,1-17.257,17.012l-83.908-.6a17.134,17.134,0,0,1-17.012-17.257l.6-83.909A17.135,17.135,0,0,1,76.573,33.342",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37987",
    "data-name": "Path 37987",
    d: "M111.009,33.517l7.877.128,7.435.132",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x2: 28.221,
    y2: 0.202,
    transform: "translate(120.568 118.326)",
    fill: "none",
    stroke: "#fc3",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    "data-name": "Ellipse 205",
    cx: 17.875,
    cy: 17.875,
    r: 17.875,
    transform: "translate(20.737 1)",
    fill: "none",
    stroke: "#fff0c1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37988",
    "data-name": "Path 37988",
    d: "M36.769,26.9a7.692,7.692,0,0,1-5.04-2.641l2.42-2.776A6.238,6.238,0,0,0,38.7,23.238c1.443,0,2.442-.511,2.442-1.376,0-.777-.888-1.266-2.6-1.421-3.4-.311-6.327-1.177-6.327-5.039,0-2.62,2.042-4.063,4.551-4.53V8.852H40.5v1.976a8.289,8.289,0,0,1,4.039,1.71l-2.175,2.774a5.821,5.821,0,0,0-3.64-1.066c-1.066,0-2.11.334-2.11,1.156,0,1.066,1.044,1.221,2.575,1.376,3.087.333,6.305,1.576,6.305,5.15,0,2.908-2.264,4.44-5.017,4.907H40.5v2.152h-3.73Z",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37989",
    "data-name": "Path 37989",
    d: "M30.487,60.007A14.743,14.743,0,1,1,15.743,45.263,14.744,14.744,0,0,1,30.487,60.007Z",
    fill: "none",
    stroke: "#fff0c1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37990",
    "data-name": "Path 37990",
    d: "M14.224,66.627a6.349,6.349,0,0,1-4.158-2.179l2-2.289a5.141,5.141,0,0,0,3.754,1.447c1.19,0,2.013-.421,2.013-1.135,0-.641-.732-1.044-2.141-1.172-2.8-.257-5.219-.971-5.219-4.156,0-2.162,1.685-3.352,3.754-3.737V51.74H17.3v1.63a6.835,6.835,0,0,1,3.333,1.41l-1.8,2.288a4.8,4.8,0,0,0-3-.879c-.879,0-1.74.276-1.74.954,0,.879.861,1.006,2.124,1.134,2.545.275,5.2,1.3,5.2,4.248,0,2.4-1.868,3.663-4.139,4.047H17.3v1.776H14.224Z",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37991",
    "data-name": "Path 37991",
    d: "M198.323,34.742V84.324h0v0l-42.946,24.793a49.265,49.265,0,0,1-5.892-16.186,50.186,50.186,0,0,1,0-17.219A49.556,49.556,0,0,1,197.112,34.75c.368-.008.736-.012,1.108-.012a.886.886,0,0,1,.1,0",
    fill: "#fc3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37992",
    "data-name": "Path 37992",
    d: "M241.115,109.03a49.5,49.5,0,0,1-42.793,24.876.879.879,0,0,1-.1,0c-.372,0-.739,0-1.107-.013a49.651,49.651,0,0,1-41.738-24.776l42.944-24.793h.009Z",
    fill: "#ffe598",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37993",
    "data-name": "Path 37993",
    d: "M255.487,78.192a49.676,49.676,0,0,1-.74,8.578A49.088,49.088,0,0,1,248.9,102.9L206.112,78.2v0h0V28.61a49.539,49.539,0,0,1,49.379,49.582Z",
    fill: "none",
    stroke: "#1c1c1c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37994",
    "data-name": "Path 37994",
    d: "M94.833,49.5h-.692a6.154,6.154,0,0,1-6.154-6.154V25.654A6.154,6.154,0,0,1,94.141,19.5h.692a6.154,6.154,0,0,1,6.154,6.154V43.346A6.154,6.154,0,0,1,94.833,49.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2931",
    "data-name": "Rectangle 2931",
    width: 13,
    height: 30,
    rx: 6.154,
    transform: "translate(87.987 19.5)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37995",
    "data-name": "Path 37995",
    d: "M143.333,49h-.692a6.154,6.154,0,0,1-6.154-6.154V25.154A6.154,6.154,0,0,1,142.641,19h.692a6.154,6.154,0,0,1,6.154,6.154V42.846A6.154,6.154,0,0,1,143.333,49",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2932",
    "data-name": "Rectangle 2932",
    width: 13,
    height: 30,
    rx: 6.154,
    transform: "translate(136.487 19)",
    fill: "none",
    stroke: "#1c1c1c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.00d8989dc1773e579e1e9db8abfdab23.svg";
export { ForwardRef as ReactComponent };